import React from "react";
import * as PropTypes from "prop-types";
import Deals from "./userMenuContexts/Deals";
import Recognition from "./userMenuContexts/Recognition";
var UserMenuContext = function (props, _a) {
    var apps = _a.apps, appPath = _a.appPath;
    switch (appPath) {
        case apps.PERKS:
        case apps.SEARCH:
            return React.createElement(Deals, null);
        case apps.RECOGNITION:
            return React.createElement(Recognition, null);
        default:
            return null;
    }
};
UserMenuContext.contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
};
export default UserMenuContext;
